module.exports = __webpack_public_path__ + "img/shop.332a5b4b.svg";